import React, { ReactNode } from 'react';
import ReactContentLoader from 'react-content-loader';
import { rgba, em } from 'polished';
import styled from 'styled-components/macro';

import colors from 'styles/themes/colors';
import { ThemeProps } from 'types/styled';

const ContentLoaderMaxWidth = styled.div<ThemeProps<'div'>>`
  width: calc(100% - ${({ theme }): string => theme.spacing.small});
  max-width: ${({ contentWidth }): string => `${em(contentWidth)}`};
  line-height: 1;
  overflow: hidden;
`;

interface IContentLoaderProps {
  speed?: number;
  /** The width of the SVG skeleton */
  width: number;
  /** The height of the SVG skeleton */
  height: number;
  /** The SVG nodes of the skeleton */
  children: ReactNode;
  /** Optional className prop to extend styling */
  className?: string;
  /** Use the same value of prop key, that will solve inconsistency on the SSR. Also see https://github.com/danilowoz/react-content-loader */
  uniquekey?: string;
  viewBox?: string;
  preserveAspectRatio?: string;
}

/** Loading animation with content indication */
const ContentLoader: React.FC<IContentLoaderProps> = (props) => {
  const {
    width,
    height,
    uniquekey,
    children,
    className,
    speed = 1,
    ...rest
  } = props;

  return (
    <ContentLoaderMaxWidth
      contentWidth={width}
      className={className}
      data-pw="content-loader"
    >
      <ReactContentLoader
        width={width}
        height={height}
        style={{
          display: 'block',
          width: `${em(width)}`,
          height: `${em(height)}`,
        }}
        speed={speed}
        foregroundColor={colors.Sand}
        backgroundColor={rgba(colors.LightGrey, 0.6)}
        uniqueKey={uniquekey}
        {...rest}
      >
        {children}
      </ReactContentLoader>
    </ContentLoaderMaxWidth>
  );
};

export default ContentLoader;
